import api from './request'

export const getPointOfInterestsByModelAndModelId = async (modelId: number, mode?: string) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const where: any = {
    model: {
      equals: modelId,
    },
  }
  if (mode) {
    where.mode = {
      equals: mode,
    }
  }
  const response = await api.get(`/point-of-interests`, {
    params: {
      where,
    },
  })
  return response.data
}

export const viewPointOfInterest = async (id: number, experienceId: number) => {
  const response = await api.post(`/poi-views/increment`, {
    poiId: id,
    experienceId,
  })
  return response.data
}
